<div class="flex flex-col bg-white">
  <div class="flex flex-row items-center justify-between p-4">
    <div class="text-sm font-bold">
      @if (options().titlePrefix | async; as title) {
        <span>{{ title?.trim() }}&nbsp;</span>
      }
      <span>{{
        {
          date: (weekSubject | async)?.startDate,
          format: 'EEEE, dd.LL.yyyy',
          timezone: options().timezone,
        } | luxon
      }}</span>
      @if (!CalendarUtils.areDatesEqual((weekSubject | async)?.startDate, (weekSubject | async)?.endDate)) {
        <span>
          &nbsp;-&nbsp;
          {{
            {
              date: (weekSubject | async)?.endDate,
              format: 'EEEE, dd.LL.yyyy',
              timezone: options().timezone,
            } | luxon
          }}
        </span>
      }
    </div>
    @if (!options().displayOptions?.hideDateSelection) {
      <div class="flex flex-row space-x-4">
        <!-- <bbit-button
        #datePickerButton
        *ngIf="options?.displayStyle === CalendarDisplayStyle.BOOKING"
        icon="mdiCalendar"
        [type]="BbitButtonType.SECONDARY"
        (click)="openDatePicker()"
        color="var(--font-color)"
      ></bbit-button> -->
        <button (click)="openDatePicker()" #datePickerButton><ng-icon name="heroCalendar"></ng-icon></button>
        <button (click)="previous()"><ng-icon name="heroChevronLeft"></ng-icon></button>
        <button (click)="next()"><ng-icon name="heroChevronRight"></ng-icon></button>
      </div>
    }
  </div>
  <div class="flex flex-row flex-auto overflow-x-auto overflow-y-hidden relative" #detailElem [ngStyle]="detailStyles | async">
    @for (day of (weekSubject | async)?.days; track day) {
      <div class="flex flex-row flex-auto divide-x divide-x-gray-300">
        @for (calendar of options().calendars | async; track calendar; let i = $index) {
          <div
            class="flex flex-col flex-auto relative min-w-[200px]"
            #dayElem
            [attr.data-date]="day.date.toISODate()"
            [attr.data-calendar]="calendar._id"
            (appAfterAddedToDom)="initializeNewEventHover(day, calendar, $any($event))"
            (click)="dayClick()"
          >
            <div class="flex flex-row items-center justify-center text-sm h-[60px] min-h-[60px] border-b border-b-gray-300 z-20 bg-white">
              {{ calendar.designation }}
            </div>
            @if (day.today) {
              <div
                class="min-h-[1px] h-[1px] max-h-[1px] absolute pointer-events-none bg-red-500 w-full z-10"
                [ngStyle]="timeIndicatorNgStyleSubject | async"
              ></div>
            }
            @for (hour of hours | async; track hour) {
              <div class="text-sm min-h-[60px] relative border-b border-b-gray-300">
                @if (i === 0) {
                  <div
                    class="text-[12px] text-gray-500 p-1 sticky left-0 top-0"
                    [style.fontSize]="options().displayOptions?.timeIndicatorFontSize"
                    #timeElem
                  >
                    {{ hour }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @for (event of filteredEvents | async; track event._id) {
      <div
        class="event"
        [ngStyle]="event._ngStyleSubject | async"
        [ngClass]="event._ngClassSubject | async"
        (click)="options().onEventClick ? options()?.onEventClick(event) : null"
      >
        <!-- (appAfterAddedToDom)="initializeInteract(event, $event)" -->
        <div class="designation">{{ event.designation }}</div>
        <div class="time">
          {{ { date: event.from, format: 'HH:mm', timezone: options().timezone } | luxon }} -
          {{ { date: event.until, format: 'HH:mm', timezone: options().timezone } | luxon }}
        </div>
        <!-- <div>{{ event.from }}</div> -->
      </div>
    }

    <div
      class="event small absolute top-0 left-0 hidden w-0 h-0 pointer-events-none overflow-hidden"
      [ngStyle]="newEventHelper._ngStyleSubject | async"
      [ngClass]="newEventHelper._ngClassSubject | async"
    >
      <div class="designation">{{ newEventHelper.designation }}</div>
      <div class="time">
        {{ { date: newEventHelper.from, format: 'HH:mm', timezone: options().timezone } | luxon }} -
        {{ { date: newEventHelper.until, format: 'HH:mm', timezone: options().timezone } | luxon }}
      </div>
    </div>
  </div>
</div>
